export class Step9 {
  constructor() {}
  intitule = 'stepper.form.commun.mapa.step9';
  getnoserviceexecutant = 'bloc_commun.mapa.getnoserviceexecutant';
  getnumboncommande = 'bloc_commun.mapa.getnumboncommande';
  getspan5 = 'bloc_commun.mapa.getspan5';
  getspan6 = 'bloc_commun.mapa.getspan6';
  getspan7 = 'bloc_commun.mapa.getspan7';
  getspan8 = 'bloc_commun.mapa.getspan8';
  getregion = 'bloc_commun.mapa.getregion';
  getdepartement = 'bloc_commun.mapa.getdepartement';
  getetat = 'bloc_commun.mapa.getetat';
  getdebiteuretranger = 'bloc_commun.mapa.getdebiteuretranger';
  getdebiteurprivepersmorale = 'bloc_commun.mapa.getdebiteurprivepersmorale';
  getdebiteurprivepersphysique = 'bloc_commun.mapa.getdebiteurprivepersphysique';
  getgroupementcollectivites = 'bloc_commun.mapa.getgroupementcollectivites';
  getcommune = 'bloc_commun.mapa.getcommune';
  getautresorganismespublics = 'bloc_commun.mapa.getautresorganismespublics';
  getetablissementspublicssante = 'bloc_commun.mapa.getetablissementspublicssante';
  getsiret = 'bloc_commun.mapa.getsiret';
  getdenomination = 'bloc_commun.mapa.getdenomination';
  getadr1 = 'bloc_commun.mapa.getadr1';
  getadr2 = 'bloc_commun.mapa.getadr2';
  getadr3 = 'bloc_commun.mapa.getadr3';
  getadr4 = 'bloc_commun.mapa.getadr4';
  getcp = 'bloc_commun.mapa.getcp';
  getville = 'bloc_commun.mapa.getville';
  getpays = 'bloc_commun.mapa.getpays';
  gettvaIntracommunautaire = 'bloc_commun.mapa.gettvaIntracommunautaire';

}
